import { SectionList } from "@module-system";
import EventEmitter from "eventemitter2";
import { Actions, Events } from "./events";

class EventManager {
  private static readonly actionEmitters: { [key: string]: EventEmitter } = {};

  private static readonly eventEmitters: { [key: string]: EventEmitter } = {};

  private static readonly newEmitter = () => {
    return new EventEmitter({
      delimiter: ".",
      wildcard: true,
      ignoreErrors: true,
      newListener: false,
      removeListener: true,
      maxListeners: 100,
      verboseMemoryLeak: true,
    });
  };

  static readonly getActionEmitter = (rtcId: string) => {
    if (!EventManager.actionEmitters[rtcId]) {
      EventManager.actionEmitters[rtcId] = this.newEmitter();
    }
    return EventManager.actionEmitters[rtcId];
  };

  static readonly removeActionEmitter = (rtcId: string) => {
    delete EventManager.actionEmitters[rtcId];
  };

  static readonly rootActionEmitter = () => {
    return EventManager.getActionEmitter("root");
  };

  static readonly getEventEmitter = (rtcId: string) => {
    if (!EventManager.eventEmitters[rtcId]) {
      EventManager.eventEmitters[rtcId] = this.newEmitter();
    }
    return EventManager.eventEmitters[rtcId];
  };

  static readonly removeEventEmitter = (rtcId: string) => {
    delete EventManager.eventEmitters[rtcId];
  };

  static readonly rootEventEmitter = () => {
    return EventManager.getEventEmitter("root");
  };
}

class ActionPayload<T> {
  payload: T;
  constructor(payload: T) {
    this.payload = payload;
  }
}

class ChangeSectionPayload extends ActionPayload<{
  section: SectionList;
  key: string;
}> {
  constructor(payload: { section: SectionList; key: string }) {
    super(payload);
  }
}

export { EventManager, Actions, Events, ActionPayload, ChangeSectionPayload };
